<template>
  <div>
    <div class="app-wrapper">
      <div class="container">
        <div class="container-inner">
        <el-col :span="12">
          <div style="margin-left: 100px;margin-top: 60px">
            <h1 class="color-main">OOPS!</h1>
            <h2 style="color: #606266">很抱歉，后端服务开小差了,请稍后重试</h2>
            <el-button style="margin-top: 20px" type="primary" round @click="handleGoMain">重试</el-button>
          </div>
        </el-col>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>
import img_404 from '@/assets/images/gif_404.gif';

export default {
  name: 'WrongPage',
  data() {
    return {
      img_404
    };
  },
  methods: {
    handleGoMain() {
      this.$router.push({ name: 'root' });
    }
  }
};
</script>

<style>
.container {
  width: 1200px;
  margin: 0 auto;
}
.container-inner {
  margin-top: 180px;
}
.img-style {
  width: auto;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/views/500.vue